<template>
  <div class="cross-detail">
    <el-dialog
    title="项目详情"
    :visible.sync="currentValue"
    :close-on-click-modal="false"
    @open="open"
    custom-class="detail"
    width="762px">
      <div class="content"  v-loading="loading">
        <div class="content-top">
          <toolTip class="title" style="width: 100%;" :title="dataset.project_name"><span>{{dataset.project_name}}</span></toolTip>
          <img v-if="dataset.approval_status === 3 && isShowImg" class="flag" src="image/img_failed.png" alt="">
          <table class="table">
            <thead>
              <th>意向客户</th>
              <th>参与团队</th>
              <th>项目骨干</th>
            </thead>
            <tbody>
              <tr>
                <td style="max-width: 250px;"><toolTip style="width:100%;" :maxWidth="'100%'" :title="dataset.customer_name">{{dataset.customer_name || '-'}}</toolTip> </td>
                <td><toolTip style="width:100%;" :maxWidth="'100%'" :title="getDepartmentName">{{getDepartmentName || '-'}}</toolTip></td>
                <td><toolTip style="width:100%;" :maxWidth="'100%'" :title="importantMember">{{importantMember || '-'}}</toolTip></td>
              </tr>
            </tbody>
          </table>
          <table class="table" style="margin-top: 22px;">
            <thead>
              <th>项目周期</th>
              <th>预计投入</th>
              <th>预计效益</th>
            </thead>
            <tbody>
              <tr>
                <td>{{dataset.project_start_time ? resetTime(dataset.project_start_time.split(' ')[0]) + '~' + resetTime(dataset.project_end_time.split(' ')[0]) : '-'}}</td>
                <td>{{dataset.expected_investment || '-'}}</td>
                <td>{{dataset.expected_benefit || '-'}}</td>
              </tr>
            </tbody>
          </table>
          <div class="remake" v-if="dataset.project_overview">
            <div>
              {{dataset.project_overview}}
            </div>
          </div>
          <div class="file" v-if="dataset.attachments && dataset.attachments.length > 0">
            <div class="file-cell" v-for="item in dataset.attachments" :key="item.id" @click="openFile(item)">
              <div class="file-cell-left">
                <img :src="getFileTypeUrl(item.attachment_type)" alt="">
                <span>{{item.attachment_name}}</span>
              </div>
              <div class="file-cell-right">
                <span>{{getfilesize(item.attachment_size)}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="comment" v-if="dataset.approval_status === 3">
          <div class="dot">
            <div class="dot-t">
              <span>{{$$(dataset,'created_user.realname')}}</span>
              <span>{{timeRest(dataset.create_time)}}</span>
            </div>
            <div class="remark">提交申请</div>
          </div>
          <div class="dot">
            <div class="dot-t">
              <span class="danger">{{$$(dataset,'approval_user.realname')}}</span>
              <span>{{timeRest(dataset.approval_time)}}</span>
            </div>
            <div class="remark">{{dataset.approval_remarks}}</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="footer" v-if="dataset.approval_status === 1">
        <div class="footer-left">{{$$(dataset,'created_user.realname')}} 提交于 {{timeRest(dataset.create_time)}}</div>
        <div class="footer-right" v-if="dataset.approval_permission">
          <wf-button type="danger" plain style="margin-right: 24px;" @click="comeback">不通过</wf-button>
          <wf-button @click="openSelectAdminMember">确认立项</wf-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="退回原因"
      :visible.sync="comebackVisible"
      :close-on-click-modal="false"
      width="592px"
      custom-class="dialog-comeback"
      @opened="openComeBack('inputTextArea')"
      @closed="closedComBack">
      <el-input ref="inputTextArea" type="textarea" v-model="approval_remarks" :autosize="{ minRows: 6}"></el-input>
      <div slot="footer" class="footer">
        <div></div>
        <div class="footer-right">
          <span class="cancel text-btn-active" @click="comebackVisible = false" style="margin-right: 24px;">取消</span>
          <wf-button @click="comminute" type="danger" :disabled="!approval_remarks" :loading="comebackLoading">确认退回</wf-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="请设置此跨团队项目的管理员"
      :visible.sync="adminMemberVisible"
      :close-on-click-modal="false"
      width="590px"
      custom-class="dialog-comeback">
      <el-cascader :options="memberOptions" placeholder="请选择项目管理员" @change="handleChosMember" ></el-cascader>
      <div slot="footer" class="footer">
        <div></div>
        <div class="footer-right">
          <wf-button @click="check" :disabled="!member_admin" :loading="adminMemberLoading">创建</wf-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from '@/services/api/home/home'
import deparApi from "@/services/api/department/department";
import { mapActions } from 'vuex'
export default {
  props: ['id','value'],
  data() {
    return {
      loading: false,
      comebackVisible: false,
      comebackLoading: false,
      dataset: {},
      approval_remarks: '',
      isShowImg: false,
      adminMemberVisible: false,
      adminMemberLoading: false,
      memberOptions: [],
      member_admin: ''
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || undefined;
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    },
    getDepartmentName() {
      return this.dataset.joined_departments ? this.dataset.joined_departments.map(res => res.name).join('、') : '-'
    },
    importantMember() {
      return this.dataset.important_members ? this.dataset.important_members.map(res => res.realname).join('、') : '-'
    }
  },
  methods: {
    ...mapActions('home/home', ['getNumberOfCrossProjects']),
    async open() {
      this.isShowImg = false
      this.loading = true
      let result = await api.readCrossProjects({id: this.id})
      this.dataset = result
      this.loading = false
      this.$nextTick(() => {
        setTimeout(() => {
          this.isShowImg = true
        },300)
      })
    },
    openFile(file) {
      this.getOssUrl(file.oss_attachment_name, (data) => {
        this.opendImgUrl(file.attachment_type, data.sign_url);
      });
    },
    comeback() {
      this.comebackVisible = true
    },
    async check() {
      this.adminMemberLoading = true
      let params = {
        id: this.dataset.id,
        member_admin: this.member_admin,
        approval_status: 2
      }
      // await this.$wfAlert('', '确认成立该项目吗？', '', '确定')
      try {
        let result = await api.crossProjectsApproval(params)
        this.currentValue = false
        // this.$emit('success', true)
        this.$message.success('项目创建成功');
        this.getNumberOfCrossProjects()
        this.$router.push('./crossProjectDetail?id=' + result.id)
      } catch (error) {
      }
      this.adminMemberLoading = false
    },
    openComeBack(ref) {
      this.$refs[ref].focus()
    },
    closedComBack() {
      this.approval_remarks = ''
    },
    async comminute() {
      this.comebackLoading = true
      let params = {
        id: this.dataset.id,
        approval_status: 3,
        approval_remarks: this.approval_remarks
      }
      try {
        await api.crossProjectsApproval(params)
        this.comebackVisible = false
        this.currentValue = false
        this.$emit('success', 3)
        this.getNumberOfCrossProjects()
      } catch (error) {
      }
      this.comebackLoading = false
    },
    async getMembers() {
      const res = await deparApi.getDepartmentUser({ working_status: '在职' })
      if (res) {
        const _list = res.departmentgroup
        for (let i = 0, len = _list.length; i < len; i++) {
          this.memberOptions.push({
            value: _list[i].depart_id,
            label: _list[i].name,
            children: []
          })
          for (let j = 0, len2 = _list[i].member.length; j < len2; j++) {
            this.memberOptions[i].children.push({
              value: _list[i].member[j].uid,
              label: _list[i].member[j].realname
            })
          }
        }
      }
    },
    handleChosMember(val) {
      this.member_admin = val ? val[val.length - 1] : ''
    },
    openSelectAdminMember() {
      this.member_admin = ''
      this.getMembers()
      this.adminMemberVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/scss/mixin';
.cross-detail {
  /deep/ {
    .detail {
      .el-dialog__body{
        color: #0D1F3C;
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 32px;
      }
      .el-dialog__header {
        border-bottom: 1px solid rgba(231,232,237,0.6);
        padding: 15px 20px;
        // padding: 0 24px;
        // height: 54px;
        // display: flex;
        // align-items: center;
        // justify-content: space-between;
        position: relative;
        z-index: 1;
        .el-dialog__headerbtn{
          top: 16px;
        }
      }
      .el-dialog__footer {
        border-top: 1px solid rgba(231,232,237,0.6);
        padding: 0 24px;
        height: 54px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
  .content {
    /deep/ {
      .title {
        font-size: 18px;
        font-weight: 500;
      }
    }
    &-top {
      padding: 0 24px;
    }
    .flag {
      position: absolute;
      top: 0;
      right: 0;
      width: 169px;
    }
    .table {
      width: 100%;
      table-layout: fixed;
      margin-top: 49px;
      td:not(:last-child) {
        padding-right: 16px;
      }
      th {
        text-align: left;
        color: rgba(32, 32, 32, 0.6);
        font-size: 14px;
        font-weight: 400;
      }
      th:nth-child(1){
        width: 35%;
      }
      tbody {
        font-size: 14px;
        font-weight: 400;
        tr {
          line-height: 38px;
        }
      }
    }
    .remake{
      padding: 16px;
      background: rgba(32, 32, 32, 0.08);
      border-radius: 4px;
      margin-top: 16px;
      &>div {
        @include ellipsis(3);
      }
    }
    .file {
      width: 100%;
      margin-top: 24px;
      .file-cell:nth-child(n-1) {
        margin-top: 16px;
      }
      .file-cell {
        padding: 0 16px;
        height: 48px;
        display: flex;
        align-items: center;
        border-radius: 4px;
        border: 1px solid rgba(231,232,237,0.6);
        justify-content: space-between;
        cursor: pointer;
        &-left {
          display: flex;
          align-items: center;
          span {
            font-size: 14px;
            font-weight: 400;
          }
          img {
            width: 28px;
            margin-right: 16px;
          }
        }
        &-right {
          color: rgba(32, 32, 32, 0.6);
          font-size: 12px;
        }
      }
    }
  }
  .footer{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: rgba(32, 32, 32, 0.6);
    &-left {
      font-size: 14px;
      font-weight: 400;
    }
    &-right {
      display: flex;
      align-items: center;
    }
  }
  .comment{
    border-top: 1px solid rgba(231,232,237,0.6);
    padding: 24px;
    padding-bottom: 2px;
    margin-top: 40px;
    .dot {
      display: flex;
      flex-direction: column;
      position: relative;
      &-t {
        font-weight: 400;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span:first-child {
          display: flex;
          align-items: center;
          &::before {
            content: '';
            display: block;
            width: 14px;
            height: 14px;
            border: 2px solid #2682FF;
            background-color: #CCE2FF;
            border-radius: 50%;
            margin-right: 16px;
            box-sizing: border-box;
          }
          &.danger {
            &::before {
              border-color: #FF3939;
              background-color: #FFB1B1;
            }
          }
        }
        span:last-child {
          color: rgba(32, 32, 32, 0.6);
          font-size: 12px;
          font-weight: 400;
        }
      }
      .remark {
        font-size: 14px;
        color: rgba(13, 31, 60, 0.8);
        font-weight: 400;
        margin-top: 16px;
        margin-left: 30px;
      }
    }
    .dot:not(:last-child) {
      padding-bottom: 32px;
      &::before {
        content: '';
        display: block;
        position: absolute;
        left: 6px;
        top: 17px;
        bottom: 0;
        border-left: 2px dashed rgba(13,31,60,0.16);
      }
    }
  }
  /deep/ {
    .dialog-comeback{
      .el-dialog__body{
        padding: 14px 20px;
      }
      .el-textarea__inner {
        background-color: rgba(32, 32, 32, 0.04);
      }
      .el-cascader{
        width: 100%;
      }
    }
  }
}
</style>
